import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';

@Component({
  selector: 'mc-pull-out',
  templateUrl: './pull-out.component.html',
  styleUrls: ['./pull-out.component.scss']
})
export class PullOutComponent implements OnInit {

  @Input()  isCollapsed = true;
  @Output() isCollapsedChange = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() { }

  toggle(): void {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapsedChange.emit(this.isCollapsed);
  }

}
